export default __webpack_public_path__ + "static/media/enable-cam-edge-pc.ed5d8779.png";